module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-index-thumbnails-1920x1080-7c03d3e8264a44e6aafa9a91a3a8e476.jpg";